(function() {
  'use strict';

  // ============================================
  // STATE
  // ============================================
  const state = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    country: '',
    selectedQuantity: null,
    customQuantity: null,
    hatSelections: [],
    logoMethods: [],
    logoFile: null,
    logoCloudinaryUrl: null,
    logoCloudinaryId: null,
    isSubmitting: false,
    isSubmitted: false,
    rep: null
  };

  let logoManager = null;
  var hasShownCurationTip = false;

  // ============================================
  // STORE ROUTING HELPERS
  // ============================================
  function getTargetStore(country) {
    if (country === 'US') return 'us';
    return 'ca';
  }

  function isCAStore() {
    var config = window.__mockupConfig;
    return config && config.currentStore && config.currentStore.indexOf('sixhats.myshopify.com') >= 0;
  }

  function isUSStore() {
    var config = window.__mockupConfig;
    return config && config.currentStore && config.currentStore.indexOf('sixhatssupply.myshopify.com') >= 0;
  }

  function shouldRedirect(country) {
    if (!country) return false;
    var config = window.__mockupConfig;
    if (!config || !config.otherStoreUrl) return false;
    if (country === 'US' && isCAStore()) return true;
    if (country === 'CA' && isUSStore()) return true;
    return false;
  }

  function saveFormStateAndRedirect() {
    var config = window.__mockupConfig;
    if (!config || !config.otherStoreUrl) return;

    var storeName = state.country === 'US' ? 'US' : 'Canadian';
    showNotification('Redirecting you to our ' + storeName + ' store...', 'info');

    var basePath = config.otherStoreMockupPath || '/pages/custom-mockup';
    var redirectUrl = config.otherStoreUrl.replace(/\/+$/, '') + basePath;

    // Pass form data via query params (localStorage doesn't work cross-domain)
    var params = new URLSearchParams();
    if (state.firstName) params.set('fn', state.firstName);
    if (state.lastName) params.set('ln', state.lastName);
    if (state.email) params.set('em', state.email);
    if (state.phone) params.set('ph', state.phone);
    if (state.company) params.set('co', state.company);
    if (state.country) params.set('ct', state.country);
    if (state.selectedQuantity) params.set('qty', state.selectedQuantity);
    if (state.rep) params.set('rep', state.rep);

    var qs = params.toString();
    if (qs) redirectUrl += '?' + qs;

    setTimeout(function() {
      window.location.href = redirectUrl;
    }, 800);
  }

  function restoreFormState() {
    try {
      var params = new URLSearchParams(window.location.search);
      // Only restore if we have the transfer params
      if (!params.has('fn') && !params.has('em')) return;

      var paramMap = {
        fn: 'firstName',
        ln: 'lastName',
        em: 'email',
        ph: 'phone',
        co: 'company',
        ct: 'country'
      };

      Object.keys(paramMap).forEach(function(param) {
        var val = params.get(param);
        if (val) {
          var stateKey = paramMap[param];
          state[stateKey] = val;
          var el = document.querySelector('[data-field="' + stateKey + '"]');
          if (el) el.value = val;
        }
      });

      // Restore rep
      var rep = params.get('rep');
      if (rep) state.rep = rep;

      // Restore quantity — click the matching quick-select button
      var qty = params.get('qty');
      if (qty) {
        var qtyBtn = document.querySelector('[data-quick-select][data-quantity="' + qty + '"]');
        if (qtyBtn) {
          qtyBtn.click();
        } else {
          var customBtn = document.querySelector('[data-quick-select][data-quantity="custom"]');
          if (customBtn) customBtn.click();
          var customInput = document.querySelector('[data-custom-quantity-input]');
          if (customInput) {
            customInput.value = qty;
            customInput.dispatchEvent(new Event('input'));
          }
        }
      }

      // Check if step 1 is complete to reveal step 2
      var step1Complete = state.firstName && state.lastName && state.email && state.phone && state.country && isValidEmail(state.email) && isValidPhone(state.phone);
      if (step1Complete) {
        revealStep(2);
      }

      updateStatusIndicators();
      showNotification('Your info has been carried over. Please re-select your hats and logo.', 'info');

      // Clean URL without reloading
      if (window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname);
      }
    } catch (e) {
      // Parse error — ignore
    }
  }

  // ============================================
  // INIT
  // ============================================
  function init() {
    setupNotificationSystem();
    setupStep1CustomerInfo();
    setupStep2Quantity();
    setupStep3HatSelection();
    setupStep4LogoMethods();
    setupStep5LogoUpload();
    setupSubmitButton();
    captureRepFromUrl();
    updateStatusIndicators();
    updateMethodAvailability();
    restoreFormState();
  }

  function captureRepFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var rep = params.get('rep') || params.get('utm');
      if (rep) {
        state.rep = rep.trim();
      }
    } catch (e) {
      // URLSearchParams not supported — silent fail
    }
  }

  // ============================================
  // NOTIFICATION SYSTEM (same as beanie-logic)
  // ============================================
  function setupNotificationSystem() {
    if (!document.getElementById('notification-container')) {
      const container = document.createElement('div');
      container.id = 'notification-container';
      container.className = 'fixed top-4 right-4 space-y-2';
      document.body.appendChild(container);
    }
  }

  function showNotification(message, type) {
    type = type || 'error';
    var container = document.getElementById('notification-container');
    if (!container) return;

    var notification = document.createElement('div');
    var bgColor = type === 'error' ? 'bg-red-500' : type === 'success' ? 'bg-green-500' : 'bg-blue-500';

    notification.className = bgColor + ' text-white px-6 py-4 rounded-lg shadow-lg flex items-center space-x-3 max-w-md';
    notification.innerHTML =
      '<svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
        (type === 'error'
          ? '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>'
          : '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>') +
      '</svg>' +
      '<span class="flex-1">' + message + '</span>' +
      '<button class="text-white hover:text-gray-200 transition-colors" onclick="this.parentElement.remove()">' +
        '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>' +
        '</svg>' +
      '</button>';

    container.appendChild(notification);

    setTimeout(function() {
      notification.style.opacity = '0';
      notification.style.transform = 'translateX(100%)';
      notification.style.transition = 'opacity 0.3s, transform 0.3s';
      setTimeout(function() { notification.remove(); }, 300);
    }, 5000);
  }

  // ============================================
  // CURATION TIP (one-time friendly nudge)
  // ============================================
  function checkCurationTip() {
    if (hasShownCurationTip) return;
    if (state.hatSelections.length > 5 && state.logoMethods.length > 2) {
      hasShownCurationTip = true;
      showCurationTip();
    }
  }

  function showCurationTip() {
    var container = document.getElementById('notification-container');
    if (!container) return;

    var tip = document.createElement('div');
    tip.setAttribute('data-curation-tip', '');
    tip.className = 'bg-white border-2 border-blue-300 text-gray-800 px-6 pt-5 pb-6 rounded-xl shadow-2xl max-w-sm';
    tip.innerHTML =
      '<div class="space-y-4">' +
        '<div class="flex items-start space-x-3">' +
          '<div class="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">' +
            '<svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
              '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>' +
            '</svg>' +
          '</div>' +
          '<div class="flex-1">' +
            '<p class="font-semibold text-blue-900 mb-1">Tip from our team</p>' +
            '<p class="text-sm" style="line-height:1.625">' +
              "Love the enthusiasm! With this many options, our team can help narrow things down \u2014 we know what\u2019s trending and what moves. " +
              "Too many mockups can actually make it harder to choose, so we\u2019re happy to curate the best combos for you." +
            '</p>' +
            '<p class="text-xs text-muted-foreground mt-2">No worries though \u2014 select as many as you like!</p>' +
          '</div>' +
          '<button class="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0" onclick="this.closest(\'[data-curation-tip]\').remove()">' +
            '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
              '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<button data-let-us-do-it class="w-full text-center text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg px-4 py-3 transition-colors">' +
          "Let Us Do It" +
        '</button>' +
      '</div>';

    container.appendChild(tip);

    // Wire up the CTA
    var ctaBtn = tip.querySelector('[data-let-us-do-it]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function() {
        handleLetUsDoIt();
        tip.remove();
      });
    }

    // Auto-dismiss after 15 seconds (longer — has a CTA)
    setTimeout(function() {
      if (tip.parentNode) {
        tip.style.opacity = '0';
        tip.style.transform = 'translateX(100%)';
        tip.style.transition = 'opacity 0.4s, transform 0.4s';
        setTimeout(function() { if (tip.parentNode) tip.remove(); }, 400);
      }
    }, 15000);
  }

  // ============================================
  // "LET US DO IT" — clear methods, keep hats, submit
  // ============================================
  function handleLetUsDoIt() {
    // Clear all logo method selections visually
    var methodCards = document.querySelectorAll('[data-logo-method]');
    methodCards.forEach(function(card) {
      card.classList.remove('ring-2', 'ring-purple-500', 'bg-purple-50');
      var overlay = card.querySelector('[data-check-overlay]');
      if (overlay) overlay.style.display = 'none';
    });

    // Set methods to special value so the team picks
    state.logoMethods = ['let-us-decide'];

    updateStatusIndicators();

    // If logo is already uploaded, submit immediately
    if (logoManager && logoManager.hasLogo()) {
      showNotification('Great choice! Submitting your request now...', 'info');
      // Small delay so the user sees the notification
      setTimeout(function() { handleSubmit(); }, 600);
    } else {
      // Still need logo — reveal Step 5 and scroll there
      revealStep(5);
      showNotification('Great choice! Just upload your logo and we\u2019ll handle the rest.', 'success');
    }
  }

  // ============================================
  // PROGRESSIVE DISCLOSURE — Step visibility
  // ============================================
  function revealStep(stepNumber) {
    var stepEl = document.querySelector('[data-step="' + stepNumber + '"]');
    if (stepEl && stepEl.style.display === 'none') {
      stepEl.style.display = 'block';
    }
  }

  // ============================================
  // STATUS INDICATORS (5 steps)
  // ============================================
  function updateStatusIndicators() {
    var hasCustomer = state.firstName && state.lastName && state.email && state.phone && state.country && isValidEmail(state.email) && isValidPhone(state.phone);
    var hasQuantity = state.selectedQuantity !== null;
    var hasHats = state.hatSelections.length > 0;
    var hasMethods = state.logoMethods.length > 0;
    var hasLogo = logoManager ? logoManager.hasLogo() : false;

    updateSingleIndicator('customer', '1', hasCustomer);
    updateSingleIndicator('quantity', '2', hasQuantity);
    updateSingleIndicator('hats', '3', hasHats);
    updateSingleIndicator('methods', '4', hasMethods);
    updateSingleIndicator('logo', '5', hasLogo);

    // Enable/disable submit
    var submitBtn = document.querySelector('[data-submit-mockup]');
    if (submitBtn) {
      var allComplete = hasCustomer && hasQuantity && hasHats && hasMethods && hasLogo;
      submitBtn.disabled = !allComplete;
    }
  }

  function updateSingleIndicator(type, number, isComplete) {
    var indicator = document.querySelector('[data-status-indicator="' + type + '"]');
    var label = document.querySelector('[data-status-label="' + type + '"]');
    if (!indicator || !label) return;

    if (isComplete) {
      indicator.classList.remove('bg-gray-300', 'text-gray-600');
      indicator.classList.add('bg-green-500', 'text-white');
      indicator.innerHTML = '&#10003;';
      label.classList.remove('text-gray-600');
      label.classList.add('text-green-600', 'font-medium');
    } else {
      indicator.classList.remove('bg-green-500', 'text-white');
      indicator.classList.add('bg-gray-300', 'text-gray-600');
      indicator.textContent = number;
      label.classList.remove('text-green-600', 'font-medium');
      label.classList.add('text-gray-600');
    }
  }

  // ============================================
  // STEP 1: Customer Information
  // ============================================
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function isValidPhone(phone) {
    // Strip non-digit characters, require at least 7 digits
    var digits = phone.replace(/\D/g, '');
    return digits.length >= 7;
  }

  function normalizePhone(phone, country) {
    var digits = phone.replace(/\D/g, '');
    // If already has country code (11+ digits starting with 1 for NA), return as-is
    if (digits.length >= 11 && digits.charAt(0) === '1') {
      return '+' + digits;
    }
    // Add country code prefix for North American numbers
    if (country === 'US' || country === 'CA') {
      if (digits.length === 10) return '+1' + digits;
      if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    }
    // For AU/NZ/Other, prefix with + if not already
    return '+' + digits;
  }

  function setupStep1CustomerInfo() {
    var fields = document.querySelectorAll('[data-step="1"] [data-field]');

    fields.forEach(function(field) {
      field.addEventListener('input', handleCustomerFieldChange);
      field.addEventListener('change', handleCustomerFieldChange);
    });
  }

  function handleCustomerFieldChange() {
    var fieldName = this.getAttribute('data-field');
    state[fieldName] = this.value.trim();

    // Email validation visual feedback
    if (fieldName === 'email') {
      var emailError = document.querySelector('[data-email-error]');
      if (emailError) {
        if (state.email && !isValidEmail(state.email)) {
          emailError.classList.remove('hidden');
        } else {
          emailError.classList.add('hidden');
        }
      }
    }

    // Phone validation visual feedback
    if (fieldName === 'phone') {
      var phoneError = document.querySelector('[data-phone-error]');
      if (phoneError) {
        if (state.phone && !isValidPhone(state.phone)) {
          phoneError.classList.remove('hidden');
        } else {
          phoneError.classList.add('hidden');
        }
      }
    }

    // Country-based store redirect
    if (fieldName === 'country' && shouldRedirect(state.country)) {
      saveFormStateAndRedirect();
      return;
    }

    // Check if step 1 is complete
    var step1Complete = state.firstName && state.lastName && state.email && state.phone && state.country && isValidEmail(state.email) && isValidPhone(state.phone);
    if (step1Complete) {
      revealStep(2);
    }

    updateStatusIndicators();
  }

  // ============================================
  // STEP 2: Quantity Selection
  // ============================================
  function setupStep2Quantity() {
    var quickSelectButtons = document.querySelectorAll('[data-step="2"] [data-quick-select]');

    quickSelectButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var quantity = this.getAttribute('data-quantity');

        // Visual feedback — highlight selected
        quickSelectButtons.forEach(function(btn) {
          btn.classList.remove('border-green-500', 'bg-green-50', 'ring-2', 'ring-green-500');
        });
        this.classList.add('border-green-500', 'bg-green-50', 'ring-2', 'ring-green-500');

        var customWrapper = document.querySelector('[data-custom-quantity-wrapper]');

        if (quantity === 'custom') {
          // Show custom input
          if (customWrapper) customWrapper.style.display = 'flex';
          var customInput = document.querySelector('[data-custom-quantity-input]');
          state.selectedQuantity = parseInt(customInput ? customInput.value : 500, 10);
          state.customQuantity = state.selectedQuantity;
        } else {
          if (customWrapper) customWrapper.style.display = 'none';
          state.selectedQuantity = parseInt(quantity, 10);
          state.customQuantity = null;
        }

        revealStep(3);
        updateStatusIndicators();
        updateMethodAvailability();
      });
    });

    // Custom quantity input handler
    var customInput = document.querySelector('[data-custom-quantity-input]');
    if (customInput) {
      customInput.addEventListener('input', function() {
        var val = Math.max(500, parseInt(this.value, 10) || 500);
        this.value = val;
        state.selectedQuantity = val;
        state.customQuantity = val;
        updateStatusIndicators();
        updateMethodAvailability();
      });
    }
  }

  // ============================================
  // STEP 3: Hat Selection (checkbox toggle)
  // ============================================
  function setupStep3HatSelection() {
    var hatCards = document.querySelectorAll('[data-mockup-hat]');

    hatCards.forEach(function(card) {
      card.addEventListener('click', function() {
        var productId = this.getAttribute('data-product-id');
        var existing = findHatIndex(productId);

        if (existing >= 0) {
          // Deselect
          state.hatSelections.splice(existing, 1);
          this.classList.remove('ring-2', 'ring-blue-500', 'bg-blue-50');
          var overlay = this.querySelector('[data-check-overlay]');
          if (overlay) overlay.style.display = 'none';
        } else {
          // Select
          state.hatSelections.push({
            productId: productId,
            variantId: this.getAttribute('data-variant-id'),
            productTitle: this.getAttribute('data-product-title'),
            productHandle: this.getAttribute('data-product-handle'),
            category: this.getAttribute('data-hat-category')
          });
          this.classList.add('ring-2', 'ring-blue-500', 'bg-blue-50');
          var overlay = this.querySelector('[data-check-overlay]');
          if (overlay) overlay.style.display = 'flex';
        }

        // Update counter
        var countEl = document.querySelector('[data-hat-count]');
        if (countEl) countEl.textContent = state.hatSelections.length;

        // Gate: at least 1 hat → reveal step 4
        if (state.hatSelections.length > 0) {
          revealStep(4);
        }

        updateStatusIndicators();
        checkCurationTip();
      });
    });
  }

  function findHatIndex(productId) {
    for (var i = 0; i < state.hatSelections.length; i++) {
      if (state.hatSelections[i].productId === productId) return i;
    }
    return -1;
  }

  // ============================================
  // STEP 4: Logo Application Methods (multi-select)
  // ============================================
  var RUBBER_MIN_QTY = 100;

  function setupStep4LogoMethods() {
    var methodCards = document.querySelectorAll('[data-logo-method]');

    methodCards.forEach(function(card) {
      card.addEventListener('click', function() {
        var method = this.getAttribute('data-logo-method');

        // Block rubber-patch if quantity is below minimum
        if (method === 'rubber-patch' && (state.selectedQuantity || 0) < RUBBER_MIN_QTY) {
          return;
        }

        var idx = state.logoMethods.indexOf(method);

        var overlay = this.querySelector('[data-check-overlay]');

        if (idx >= 0) {
          // Deselect
          state.logoMethods.splice(idx, 1);
          this.classList.remove('ring-2', 'ring-purple-500', 'bg-purple-50');
          if (overlay) overlay.style.display = 'none';
        } else {
          // Select
          state.logoMethods.push(method);
          this.classList.add('ring-2', 'ring-purple-500', 'bg-purple-50');
          if (overlay) overlay.style.display = 'flex';
        }

        // Gate: at least 1 method → reveal step 5
        if (state.logoMethods.length > 0) {
          revealStep(5);
        }

        updateStatusIndicators();
        checkCurationTip();
      });
    });
  }

  function updateMethodAvailability() {
    var rubberCard = document.querySelector('[data-logo-method="rubber-patch"]');
    if (!rubberCard) return;

    var isAvailable = (state.selectedQuantity || 0) >= RUBBER_MIN_QTY;

    // Toggle disabled styling
    rubberCard.classList.toggle('opacity-50', !isAvailable);
    rubberCard.classList.toggle('cursor-not-allowed', !isAvailable);
    rubberCard.classList.toggle('cursor-pointer', isAvailable);

    // Add or remove "50+ hats" badge
    var badge = rubberCard.querySelector('[data-method-badge]');
    if (!badge) {
      badge = document.createElement('div');
      badge.setAttribute('data-method-badge', '');
      badge.className = 'absolute top-2 right-2 z-10 px-2 py-1 text-xs font-medium rounded-full';
      var imgContainer = rubberCard.querySelector('.relative');
      if (imgContainer) imgContainer.appendChild(badge);
    }

    if (isAvailable) {
      badge.className = 'absolute top-2 right-2 z-10 px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-700 border border-green-300';
      badge.textContent = 'Available';
    } else {
      badge.className = 'absolute top-2 right-2 z-10 px-2 py-1 text-xs font-medium rounded-full bg-orange-100 text-orange-700 border border-orange-300';
      badge.textContent = RUBBER_MIN_QTY + '+ hats';
    }

    // If rubber was selected but qty dropped below min, deselect it
    if (!isAvailable) {
      var idx = state.logoMethods.indexOf('rubber-patch');
      if (idx >= 0) {
        state.logoMethods.splice(idx, 1);
        rubberCard.classList.remove('ring-2', 'ring-purple-500', 'bg-purple-50');
        var overlay = rubberCard.querySelector('[data-check-overlay]');
        if (overlay) overlay.style.display = 'none';
      }
    }
  }

  // ============================================
  // STEP 5: Logo Upload (reuse LogoUploadManager)
  // ============================================
  var LogoUploadManager = (function() {
    function LUM() {
      this.logoFile = null;
      this.logoBase64 = null;
      this.maxFileSizeMB = 10;
      this.allowedTypes = [
        'image/png', 'image/jpeg', 'image/jpg', 'image/gif',
        'image/svg+xml', 'application/pdf', 'application/postscript',
        'application/illustrator', 'application/vnd.adobe.illustrator'
      ];
      this.allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.pdf', '.eps', '.ai'];
      this._init();
    }

    LUM.prototype._init = function() {
      var self = this;
      var uploadInput = document.querySelector('[data-logo-upload]');
      if (!uploadInput) return;

      uploadInput.addEventListener('change', function(e) {
        self.handleFileSelect(e);
      });
    };

    LUM.prototype.handleFileSelect = function(event) {
      var file = event.target.files[0];
      if (!file) return;

      var fileName = file.name.toLowerCase();
      var fileExtension = fileName.substring(fileName.lastIndexOf('.'));

      var validMimeType = this.allowedTypes.indexOf(file.type) >= 0;
      var validExtension = this.allowedExtensions.indexOf(fileExtension) >= 0;

      if (!validMimeType && !validExtension) {
        showNotification('Invalid file type. Please upload PNG, JPG, GIF, SVG, PDF, EPS, or AI files only.', 'error');
        event.target.value = '';
        return;
      }

      var fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > this.maxFileSizeMB) {
        showNotification('File too large. Maximum size is ' + this.maxFileSizeMB + 'MB.', 'error');
        event.target.value = '';
        return;
      }

      this.logoFile = file;
      state.logoFile = file;
      this._convertToBase64(file);
    };

    LUM.prototype._convertToBase64 = function(file) {
      var self = this;
      var reader = new FileReader();

      reader.onload = function(e) {
        self.logoBase64 = e.target.result;
        self._updateUI(file);
        updateStatusIndicators();
        showNotification('Logo uploaded successfully!', 'success');
      };

      reader.onerror = function() {
        showNotification('Error reading file. Please try again.', 'error');
      };

      reader.readAsDataURL(file);
    };

    LUM.prototype._updateUI = function(file) {
      var labelElement = document.querySelector('[data-logo-label]');
      if (!labelElement) return;

      var fileName = file.name.toLowerCase();
      var fileExtension = fileName.substring(fileName.lastIndexOf('.')).toUpperCase();
      var isImage = file.type.startsWith('image/') && !fileName.endsWith('.eps');

      if (isImage && this.logoBase64) {
        labelElement.innerHTML =
          '<div class="flex items-center space-x-4">' +
            '<img src="' + this.logoBase64 + '" alt="Logo preview" class="w-16 h-16 object-contain border border-gray-300 rounded">' +
            '<div class="text-left">' +
              '<p class="text-lg font-medium text-green-600">&#10003; ' + file.name + '</p>' +
              '<p class="text-sm text-muted-foreground">' + (file.size / 1024).toFixed(1) + ' KB &bull; ' + fileExtension + '</p>' +
            '</div>' +
          '</div>';
      } else {
        labelElement.innerHTML =
          '<div class="flex items-center space-x-4">' +
            '<div class="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 border-2 border-blue-300 rounded-lg">' +
              '<svg class="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
                '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>' +
              '</svg>' +
            '</div>' +
            '<div class="text-left">' +
              '<p class="text-lg font-medium text-green-600">&#10003; ' + file.name + '</p>' +
              '<p class="text-sm text-muted-foreground">' + (file.size / 1024).toFixed(1) + ' KB &bull; ' + fileExtension + '</p>' +
            '</div>' +
          '</div>';
      }
    };

    LUM.prototype.hasLogo = function() {
      return this.logoFile !== null && this.logoBase64 !== null;
    };

    LUM.prototype.getLogoData = function() {
      if (!this.hasLogo()) return null;
      return {
        fileName: this.logoFile.name,
        fileType: this.logoFile.type || 'application/octet-stream',
        fileSize: this.logoFile.size,
        base64Data: this.logoBase64
      };
    };

    return LUM;
  })();

  function setupStep5LogoUpload() {
    logoManager = new LogoUploadManager();
  }

  // ============================================
  // CLOUDINARY UPLOAD
  // ============================================
  function uploadLogoToCloudinary(logoData) {
    var CLOUD_NAME = 'dsvcreexw';
    var UPLOAD_PRESET = 'sixhats_custom_logo';

    var formData = new FormData();
    formData.append('file', logoData.base64Data);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', 'mockup-orders');

    var timestamp = new Date().toISOString();
    formData.append('context', 'original_filename=' + logoData.fileName + '|upload_date=' + timestamp);
    formData.append('tags', 'mockup-request,logo,free-mockup');

    return fetch('https://api.cloudinary.com/v1_1/' + CLOUD_NAME + '/upload', {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(errorData) {
          throw new Error(errorData.error ? errorData.error.message : 'Upload failed');
        });
      }
      return response.json();
    })
    .then(function(result) {
      return {
        success: true,
        url: result.secure_url,
        publicId: result.public_id,
        format: result.format,
        bytes: result.bytes
      };
    })
    .catch(function(error) {
      console.error('Cloudinary upload error:', error);
      return { success: false, error: error.message };
    });
  }

  // ============================================
  // SUBMIT
  // ============================================
  function setupSubmitButton() {
    var submitBtn = document.querySelector('[data-submit-mockup]');
    if (submitBtn) {
      submitBtn.addEventListener('click', handleSubmit);
    }
  }

  function handleSubmit() {
    if (state.isSubmitting || state.isSubmitted) return;

    // Final validation
    if (!state.firstName || !state.lastName || !state.email || !state.phone || !state.country) {
      showNotification('Please complete your contact information.', 'error');
      return;
    }
    if (!isValidEmail(state.email)) {
      showNotification('Please enter a valid email address.', 'error');
      return;
    }
    if (!isValidPhone(state.phone)) {
      showNotification('Please enter a valid phone number (at least 7 digits).', 'error');
      return;
    }
    if (!state.selectedQuantity) {
      showNotification('Please select a quantity.', 'error');
      return;
    }
    if (state.hatSelections.length === 0) {
      showNotification('Please select at least one hat color.', 'error');
      return;
    }
    if (state.logoMethods.length === 0) {
      showNotification('Please select at least one logo application method.', 'error');
      return;
    }
    if (!logoManager || !logoManager.hasLogo()) {
      showNotification('Please upload your logo file.', 'error');
      return;
    }

    state.isSubmitting = true;

    var submitBtn = document.querySelector('[data-submit-mockup]');
    var originalHTML = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.innerHTML =
      '<svg class="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">' +
        '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
        '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>' +
      '</svg>' +
      'Uploading logo...';

    var logoData = logoManager.getLogoData();

    uploadLogoToCloudinary(logoData)
      .then(function(uploadResult) {
        if (!uploadResult.success) {
          throw new Error('Logo upload failed: ' + uploadResult.error);
        }

        state.logoCloudinaryUrl = uploadResult.url;
        state.logoCloudinaryId = uploadResult.publicId;

        submitBtn.innerHTML =
          '<svg class="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">' +
            '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
            '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>' +
          '</svg>' +
          'Submitting request...';

        // Build line items from hat selections (variant IDs)
        // Distribute selected quantity across hats: first hat gets the bulk, others get 1 each
        var totalQty = state.selectedQuantity || 1;
        var lineItems = state.hatSelections.map(function(hat, index) {
          var qty;
          if (index === 0) {
            qty = totalQty - (state.hatSelections.length - 1);
            if (qty < 1) qty = 1;
          } else {
            qty = 1;
          }
          return {
            variant_id: hat.variantId,
            quantity: qty
          };
        });

        // Build order note with quantity, methods, and logo info
        var methodLabels = {
          'embroidery': 'Embroidery',
          'fabric-patch': 'Full Color Fabric Patch',
          'leather-tan': 'Leather (Tan)',
          'leather-black-gold': 'Leather (Black/Gold)',
          'leather-black-silver': 'Leather (Black/Silver)',
          'leather-rawhide': 'Leather (Rawhide)',
          'cork-patch': 'Cork Patch',
          'rubber-patch': 'Rubber/PVC Patch',
          'let-us-decide': 'Let Us Decide'
        };
        var methodNames = state.logoMethods.map(function(m) {
          return methodLabels[m] || m;
        });

        var noteLines = [
          'FREE MOCKUP REQUEST',
          '====================',
          'Quantity: ' + state.selectedQuantity,
          '',
          'LOGO METHODS:',
        ];
        methodNames.forEach(function(name) {
          noteLines.push('- ' + name);
        });
        noteLines.push('');
        noteLines.push('LOGO FILE:');
        noteLines.push('- URL: ' + state.logoCloudinaryUrl);
        noteLines.push('- Original: ' + logoData.fileName);
        noteLines.push('- Type: ' + logoData.fileType);
        noteLines.push('- Size: ' + Math.round(logoData.fileSize / 1024) + ' KB');

        if (state.rep) {
          noteLines.push('');
          noteLines.push('REFERRED BY: ' + state.rep);
        }

        // Build payload
        var payload = {
          customer: {
            first_name: state.firstName,
            last_name: state.lastName,
            email: state.email,
            phone: normalizePhone(state.phone, state.country),
            company: state.company,
            country: state.country
          },
          quantity: state.selectedQuantity,
          hat_selections: state.hatSelections.map(function(hat) {
            return {
              product_id: hat.productId,
              product_title: hat.productTitle,
              product_handle: hat.productHandle,
              category: hat.category
            };
          }),
          logo_methods: state.logoMethods,
          line_items: lineItems,
          note: noteLines.join('\n'),
          logo: {
            url: state.logoCloudinaryUrl,
            cloudinary_id: state.logoCloudinaryId,
            original_filename: logoData.fileName,
            file_type: logoData.fileType,
            file_size: logoData.fileSize
          },
          rep: state.rep || null,
          target_store: getTargetStore(state.country)
        };

        var appProxyUrl = (window.__mockupConfig && window.__mockupConfig.appProxyUrl) || '/apps/sixhats/draft-orders';

        return fetch(appProxyUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function(response) {
        if (!response.ok) {
          return response.text().then(function(body) {
            var data;
            try { data = JSON.parse(body); } catch (e) { data = null; }
            if (response.status === 429) {
              throw new Error('Too many requests. Please wait a few minutes and try again.');
            }
            throw new Error((data && data.error) || 'Submission failed (HTTP ' + response.status + '). Please try again later.');
          });
        }
        return response.json();
      })
      .then(function(result) {
        state.isSubmitted = true;
        showSuccessPanel();
        showNotification('Mockup request submitted successfully!', 'success');
      })
      .catch(function(error) {
        console.error('Submission error:', error);
        showNotification(error.message, 'error');
        state.isSubmitting = false;
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHTML;
      });
  }

  // ============================================
  // SUCCESS PANEL
  // ============================================
  function showSuccessPanel() {
    // Hide the form
    var form = document.querySelector('[data-mockup-form]');
    if (form) {
      // Hide all children except the success panel
      var children = form.children;
      for (var i = 0; i < children.length; i++) {
        if (!children[i].hasAttribute('data-success-panel')) {
          children[i].style.display = 'none';
        }
      }
    }

    // Show success panel and scroll it into view
    var successPanel = document.querySelector('[data-success-panel]');
    if (successPanel) {
      successPanel.style.display = 'block';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Show email
    var emailEl = document.querySelector('[data-success-email]');
    if (emailEl) {
      emailEl.textContent = "We'll email your mockup to " + state.email;
    }
  }

  // ============================================
  // DOM READY
  // ============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
